var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoundOff = function SvgSoundOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sound-off_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sound-off_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.222 13.97v27.808L16 32.888v-1.395L30.222 13.97Zm5.334-10.834L32.804.889l-6.127 7.55L16 15.111v6.482l-3.556 4.38V15.111h-7.11V32.89h1.498L0 41.309l2.752 2.247 32.804-40.42Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sound-off_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sound-off_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.556.889h42.667v42.667H-3.556z"
  })))));
};
export default SvgSoundOff;